import React from 'react';
import axios from 'axios';
import { useEffect, useCallback } from 'react';
import styles from './home.module.css';
import AlertsTable from '../../components/AlertsTable';
import { useAuth0 } from '@auth0/auth0-react';
import LoginButton from '../../components/LoginButton';


export default function Home() {
	const { isAuthenticated, user, getAccessTokenSilently } = useAuth0();

	const [loading, setLoading] = React.useState(false);
	const [alerts, setAlerts] = React.useState([]);

	const fetchAlerts = useCallback(async () => {
		try {
			setLoading(true);

			const token = await getAccessTokenSilently();

			const response = await axios.get('/api/alerts/profile/active', {
				headers: {
					Authorization: `Bearer ${token}`
				}
			});
			
			if (response.data && response.data.alerts) {
				setAlerts(response.data.alerts);
			}
		} catch (err) {
			console.error(err);
		} finally {
			setLoading(false);
		}
	}, [getAccessTokenSilently]);

	useEffect(() => {
		if (isAuthenticated) {
			fetchAlerts();
		}
	}, [isAuthenticated, fetchAlerts]);

	return (
		<div className={styles.container}>
			{isAuthenticated ? (
				<>
					<h1>Welcome to Train Price Alerts, {user ? user.name : "dude"}!</h1>
					<p>Below are the active alerts that the program is monitoring for you.</p>
					<p>The suggested workflow is to buy a FLEX train ticket for whenever you'd like to travel, then set an alert for that same trip at the price you purchased it at.</p>
					<p>Then when you get an alert, buy the new, cheaper train ticket and cancel the old one!</p>
					<p>To create a new alert, navigate to the 'Create Alert' page in the nav bar at the top.</p>
					<AlertsTable alerts={alerts} loading={loading} fetchAlerts={fetchAlerts} getAccessTokenSilently={getAccessTokenSilently} />
				</>
			) : (
				<>
					<h1>Welcome to Train Price Alerts!</h1>
					<p>Please log in or create an account to use the application.</p>
					<LoginButton />
				</>
			)}
		</div>
	);
}